export default "__VITE_ASSET__BfvlrHF0__"